import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';
import { formatDateBr } from '@core/utils/filter';
import SLSClienteTipoPedidoService from '@/services/Cadastros/Cliente/SLSClienteTipoPedido.service';
// Notification
import { useToast } from 'vue-toastification/composition';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default function useUsersList(nameModule) {
  // Use toast
  const toast = useToast();
  const sLSClienteTipoPedidoService = new SLSClienteTipoPedidoService();
  const refClienteTipoPedidoListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: 'cliente.clientenomefantasia', label: 'Cliente', sortable: false },
    { key: 'tipopedido.tipopedidodescricao', label: 'Tipo Pedido', sortable: true },
    { key: 'actions', label: 'Ações', sortable: false },
  ];
  const perPage = ref(10);
  const totalClienteTipoPedido = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref('');
  const sortBy = ref('clienteid');
  const isSortDirDesc = ref(false);
  const overlay = ref(true);
  const statusFilter = ref(null);

  const dataMeta = computed(() => {
    const localItemsCount = refClienteTipoPedidoListTable.value ? refClienteTipoPedidoListTable.value.localItems.length : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalClienteTipoPedido.value,
    };
  });

  const refetchData = () => {
    refClienteTipoPedidoListTable.value.refresh();
  };

  watch([currentPage, perPage, searchQuery, statusFilter], () => {
    refetchData();
  });

  const fetchClienteTipoPedido = (ctx, callback) => {
    overlay.value = true;
    sLSClienteTipoPedidoService.index({
      q: searchQuery.value,
      perPage: perPage.value,
      page: currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      fullObject: true,
    }).then((response) => {
      const { data, total } = response;
      overlay.value = false;
      callback(data);
      perPage.value = response.perPage;
      currentPage.value = response.page;
      totalClienteTipoPedido.value = total;
    })
      .catch((error) => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching users list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });
      });
  };

  const create = async (body) => {
    try {
      const response = await sLSClienteTipoPedidoService.store(body);
      refetchData();
      if (response.message === 'Registro já existe no banco de dados') {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Registro já existe no banco de dados!',
            body: response.message, // Usar a mensagem da resposta
            icon: 'CheckCircleIcon',
            variant: 'danger',
          },
        });
      } else {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Sucesso',
            body: 'Cliente Tipo Pedido criado com sucesso!',
            icon: 'CheckCircleIcon',
            variant: 'success',
          },
        });
      }
      return response; // Se necessário
    } catch (error) {
      toast({
        component: ToastificationContent,
        props: {
          title: 'Erro',
          body: 'Ocorreu um erro ao criar Cliente Tipo Pedido.',
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      });
      throw error; // Se necessário
    }
  };

  const Updated = async (body) => {
    await sLSClienteTipoPedidoService.update(body);
    refetchData();
  };

  const removerData = async (data) => {
    await sLSClienteTipoPedidoService.destroy(data);
    refetchData();
  };

  const resolveTypeFieldText = type => {
    if (type === 'VARCHAR') return 'Texto';
    if (type === 'BOOLEAN') return 'Verdadeiro/Falso';
    if (type === 'DATE') return 'Data';
    if (type === 'DATETIME') return 'Data e Hora';
    if (type === 'DECIMAL') return 'Monetário';
    if (type === 'TEXT') return 'Texto Longo';
    if (type === 'INTEGER' || type === 'INT') return 'Númerico';
    return 'Sem Tipo';
  };
  const resolveTypeFieldIcon = type => {
    if (type === 'VARCHAR') return 'tabler:abc';
    if (type === 'BOOLEAN') return 'Verdadeiro/Falso';
    if (type === 'DATE') return 'system-uicons:calendar-date';
    if (type === 'DATETIME') return 'formkit:datetime';
    if (type === 'TEXT') return 'mdi:text-long';
    if (type === 'DECIMAL') return 'tabler:decimal';
    if (type === 'DECIMAL' || type === 'INTEGER' || type === 'INT') return 'tabler:123';
    return 'nonicons:type-16';
  };

  const resolveItemStatusVariant = (status) => {
    if (status === 'PENDING') return 'light-warning';
    if (status === 'ATIVO') return 'light-success';
    if (status === 'INATIVO') return 'light-danger';
    return 'primary';
  };

  return {
    fetchClienteTipoPedido,
    tableColumns,
    perPage,
    currentPage,
    totalClienteTipoPedido,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refClienteTipoPedidoListTable,
    overlay,
    resolveTypeFieldText,
    resolveTypeFieldIcon,
    resolveItemStatusVariant,
    refetchData,
    create,
    Updated,

    // Extra Filters
    statusFilter,
    removerData,
  };
}
